import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Reveal } from '../Reveal';
export function Garantia() {
  return <section aria-labelledby="garantia-titulo" className="w-full bg-bordo px-4 py-16 sm:px-6 sm:py-20" data-id="element-127" data-mp="pw4xri1lbe1d">
      <div className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="lw4ad7wijsi6">
        <Reveal data-id="element-129" data-mp="gwhvku11e479">
          <span className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border-2 border-dorado bg-white/5 shadow-card" data-id="element-130" data-mp="gwzzmctxxmpq">
            <ShieldCheck className="h-12 w-12 text-dorado" aria-hidden="true" data-id="element-131" data-mp="1dlpfjxm0c592" />
          </span>
        </Reveal>

        <Reveal delay={0.05} data-id="element-132" data-mp="19n044akj4xs2">
          <h2 id="garantia-titulo" className="mt-8 font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-133" data-mp="14tnjebiz1b4l">
            GARANTÍA PROFES DE TELAS RESUELTO — 7 DÍAS
          </h2>
        </Reveal>

        <Reveal delay={0.07} data-id="element-134" data-mp="1xa8207fmp4k2">
          <div className="mt-8 space-y-4 text-white/90" data-id="element-135" data-mp="1xbjceq3kxak5">
            <p className="text-base sm:text-lg" data-id="element-136" data-mp="1sjrnsl3zhewn">Abrís los 7 tomos. Revisás los 5 bonos. Los usás en tu clase si querés.</p>
            <p className="text-base font-bold text-dorado sm:text-lg" style={{
            fontSize: "17px",
            fontWeight: "900",
            color: "#08BF3F"
          }} data-id="element-137" data-mp="11mcd4loojqcm">
              Si en 7 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="text-base sm:text-lg" data-id="element-138" data-mp="stis07mjxwqu">Sin preguntas. Sin formularios. Sin drama.</p>
            <p className="mx-auto max-w-2xl text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-139" data-mp="wukvj0ni4uym">
              La confianza que tenemos en Profes de Telas Resuelto™ nos permite hacer esta promesa sin dudar.
              Más de 300 profes de telas de todo el país ya lo saben.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.09} data-id="element-140" data-mp="9xj0exxhkv7s">
          <p className="mx-auto mt-9 w-fit rounded-full border border-dorado/60 bg-white/5 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-dorado sm:text-sm" style={{
          color: "#7ED983",
          borderColor: "#83D97E"
        }} data-id="element-141" data-mp="dwrslycvol18">
            Tasa de devoluciones menor al 1%
          </p>
        </Reveal>
      </div>
    </section>;
}